import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getAuthHeaders } from "./authHeaders";

export const DRIVO_URL = process.env.REACT_APP_API_URL;

const httpLink = new HttpLink({ uri: `${DRIVO_URL}/graphql` });

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      ...getAuthHeaders(),
    },
  };
});

function offsetMerge() {
  return (existing = { items: [] }, incoming, { args }) => {
    const offset = (args && args.offset) || 0;
    const incomingItems = incoming.items || [];

    // offset = 0, replace everything
    if (offset === 0) {
      return incoming;
    }

    const existingItems = existing.items || [];
    const merged = existingItems.slice(0);

    for (let i = 0; i < incomingItems.length; i++) {
      merged[offset + i] = incomingItems[i];
    }

    // truncate to prevent stale tail
    const safeLength = offset + incomingItems.length;

    return {
      ...incoming,
      items: merged.slice(0, safeLength),
    };
  };
}

const client = new ApolloClient({
  /**
   * Off because the x-installation-id header decides which hotel a query is for,
   * but Apollo matches in-flight requests on query and variables only. With it
   * on, switching hotel while a query is loading attaches the new hotel's page
   * to the old hotel's request and shows the old hotel's data.
   */
  queryDeduplication: false,
  link: ApolloLink.from([authLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          listBookings: {
            keyArgs: [
              "search",
              "status",
              "startDayFrom",
              "startDayTo",
              "orderBy",
            ],
            merge: offsetMerge(),
          },
          listEvents: {
            keyArgs: ["search", "gateType"],
            merge: offsetMerge(),
          },
        },
      },
    },
  }),
});

export default client;
